




























import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { successButtonColorClass } from "@/utlitities/color";
import { UserStore } from "@/store/user-module";

@Component({
  inheritAttrs: false
})
export default class StInput2 extends Vue {
  @Prop() label!: string;
  @Prop() name!: string;
  @Prop() rules!: string;
  @Prop() value!: any;
  @Prop() inputClass!: string;
  @Prop() valImmediate!: boolean;
  @Prop() focus!: boolean;
  @Prop() markOnFocus!: boolean;
  @Prop() disabled!: boolean;
  @Prop() small!: boolean;

  mounted() {
    if (this.focus && (window.innerWidth > 960)) (this.$refs.inputfield as HTMLInputElement).focus();
  }

  get successButtonColor() {
    return successButtonColorClass(UserStore.userSettings.successButtonColor);
  }

  get hasAddonSlot() {
    return this.$slots.addon;
  }

  mark() {
    if (this.markOnFocus) {
      (this.$refs.inputfield as HTMLInputElement).select();
    }
  }

  @Emit("input")
  input(event: any) {
    return event.currentTarget.value;
  }
}
